// Copy for the two Stripe return pages. `context` is a query param we put
// on return_url BEFORE Stripe appends payment_intent / redirect_status,
// so it survives the round-trip as `?context=…&payment_intent=…`.
//
// MembershipThankYou polls GET /api/membership/receipt, which looks up
// membership_enrollments by PaymentIntent id. Extra seats live in
// hh_seat_purchases, so that poll would never succeed — those flows skip
// it (pollReceipt: false) and point the member at My Account instead.

const MEMBERSHIP = {
  pollReceipt: true,
  kicker: 'Membership 5787  ·  from the kehilla',
  title: 'Thank you',
  titleAccent: 'for joining.',
  body: 'Your payment was successful. A receipt is on its way to your email.',
  primaryHref: '/',
  primaryLabel: 'Back to Home',
  secondaryHref: '/events',
  secondaryLabel: 'See Upcoming Events',
  failHref: '/membership2026',
  failLabel: 'Back to Membership',
};

const GUEST_SEATS = {
  pollReceipt: true,
  kicker: 'High Holiday seats  ·  KBT',
  title: 'Your seats are reserved.',
  titleAccent: null,
  body: 'Your payment was successful. A receipt is on its way to your email.',
  primaryHref: '/',
  primaryLabel: 'Back to Home',
  secondaryHref: '/membership2026',
  secondaryLabel: 'Become a member',
  failHref: '/membership2026',
  failLabel: 'Back to Membership',
};

const EXTRA_SEATS = {
  pollReceipt: false,
  kicker: 'High Holiday seats  ·  KBT',
  title: 'Your seats are reserved.',
  titleAccent: null,
  body: 'Your payment was successful. The names will show up under High Holiday Seats in My Account shortly.',
  primaryHref: '/my-account?section=seats',
  primaryLabel: 'View your seats',
  secondaryHref: '/',
  secondaryLabel: 'Back to Home',
  failHref: '/my-account?section=seats',
  failLabel: 'Back to seats',
};

const DONATION = {
  kicker: 'Thank you  ·  from the kehilla',
  title: 'Your gift',
  titleAccent: 'landed safely.',
  body: "Your payment was successful. We're deeply grateful — every dollar opens another seat at the table.",
  primaryHref: '/',
  primaryLabel: 'Back to Home',
  failHref: '/donate-now',
  failLabel: 'Back to Donate',
};

const INVOICE = {
  kicker: 'Payment received  ·  KBT',
  title: 'Payment received.',
  titleAccent: null,
  body: 'Your payment was successful and your invoice is now paid.',
  primaryHref: '/my-account',
  primaryLabel: 'Back to My Account',
  failHref: '/my-account',
  failLabel: 'Back to My Account',
};

const PLAN = {
  kicker: 'Payment plan  ·  KBT',
  title: 'Your payment plan is set up.',
  titleAccent: null,
  body: 'Your first payment went through. Remaining installments will be charged automatically.',
  primaryHref: '/my-account',
  primaryLabel: 'Back to My Account',
  failHref: '/my-account',
  failLabel: 'Back to My Account',
};

const PAY_LINK_OFFICE = 'accounting@kbtla.org or 310-363-0889';

// Pay-link payers have no login (see PayInvoice.js) — unlike every other
// context above, this one must never point at /my-account.
const PAY_LINK = {
  kicker: 'Payment received  ·  KBT',
  title: 'Thank you for your payment.',
  titleAccent: null,
  body: 'Your payment was successful. A receipt is on its way to your email.',
  primaryHref: '/',
  primaryLabel: 'Back to Home',
  // Overrides for the processing/failure branches CheckoutSuccess renders
  // (other contexts keep that branch's generic copy).
  processingTitle: 'Your bank payment is processing.',
  processingBody:
    'ACH bank payments usually clear within 4 business days. There is nothing more you need to do — a receipt will follow by email once it does.',
  failTitle: "We couldn't confirm that payment.",
  failBody: `No charge went through. Please use the payment link from your invoice email to try again, or contact the office at ${PAY_LINK_OFFICE}.`,
  failHref: '/',
  failLabel: 'Back to Home',
};

const PAY_LINK_PLAN = {
  kicker: 'Payment plan  ·  KBT',
  title: 'Your payment plan is set up.',
  titleAccent: null,
  body: 'Your payment method is saved. Your payments will be charged automatically on the schedule you chose, and each payment is emailed to you as a receipt.',
  noReceiptLine: true,
  primaryHref: '/',
  primaryLabel: 'Back to Home',
  failTitle: "We couldn't save that payment method.",
  failBody: `Nothing was charged. Please use the payment link from your invoice email to try again, or contact the office at ${PAY_LINK_OFFICE}.`,
  failHref: '/',
  failLabel: 'Back to Home',
};

export const getMembershipThankYouCopy = (context) => {
  if (context === 'guest-seats') return GUEST_SEATS;
  if (context === 'extra-seats') return EXTRA_SEATS;
  return MEMBERSHIP;
};

export const getCheckoutSuccessCopy = (context) => {
  if (context === 'invoice') return INVOICE;
  if (context === 'plan') return PLAN;
  if (context === 'paylink') return PAY_LINK;
  if (context === 'paylink-plan') return PAY_LINK_PLAN;
  return DONATION;
};
